
    import React from 'react';
    import ReactDOM from 'react-dom';
    import Component from '/home/circleci/app/packages/layout-header-component/src/entries/LoggedOut';

    const element = typeof document !== 'undefined' && document.querySelector('#LayoutHeaderComponent-LoggedOut-component');

    if (element) {
        const props = window.initialData['LayoutHeaderComponent-LoggedOut'];

        ReactDOM.render(
            <Component {...props}/>,
            element
        );
    }

    export default Component;
    